module.exports = __webpack_public_path__ + "static/media/logo_white.45834b5f.png";